import { Layout } from '@/components/layout';
import { EncounterOutlet } from '@/outlets/encounter-outlet';
import { CancelVisitPage } from '@/pages/cancel-visit/cancel-visit-page';
import { ReviewPage } from '@/pages/visit-flow/review/review-page';
import { PoliciesConsentPage } from '@/pages/visit-flow/policies-consent/policies-consent-page';
import { HealthAndLifestylePage } from '@/pages/visit-flow/health-and-lifestyle/health-and-lifestyle-page';
import { PaymentPage } from '@/pages/visit-flow/payment/payment-page';
import { PharmacySelectionPage } from '@/pages/visit-flow/pharmacy-selection/pharmacy-selection-page';
import { PharmacyTypeSelectionPage } from '@/pages/visit-flow/pharmacy-selection/pharmacy-type-selection-page';
import { PreScreenQuestionsPage } from '@/pages/visit-flow/pre-screen-questions/pre-screen-questions-page';
import { ProviderSelectionPage } from '@/pages/visit-flow/provider-selection/provider-selection-page';
import { VariableQuestionsPage } from '@/pages/visit-flow/variable-questions/variable-questions-page';
import { Route } from '@/util/react-router-dom';
import { VisitNavigationOutlet } from '@/contexts/visit-navigation-context';
import { InsuranceInformationPage } from '@/pages/visit-flow/insurance-information/insurance-information-page';
import { InsuranceCoveragePage } from '@/pages/visit-flow/insurance-information/insurance-coverage-page';
import { MedicalHistoryPage } from '@/pages/visit-flow/medical-history/medical-history-page';
import { VouchedPage } from '@/pages/vouched/vouched-page';
import { IdvRejectionPage } from '@/pages/vouched/rejection-page';
import { PaymentSuccessPage } from '@/pages/visit-flow/payment/payment-success-page';
import { ManualRequestPage } from '@/pages/vouched/manual-request-page';
import { TreatmentPlanPage } from '@/pages/visit-flow/treatment-plan/treatment-plan-page';
import { DetailsPage } from '@/pages/visit-flow/treatment-plan/details-page';
import { UpdateImagesPage } from '@/pages/visit-flow/update-images/update-images-page';
import { MessagesPage } from '@/pages/visit-flow/treatment-plan/messages-page';

export const visitRoutes = (
  <Route path="visit" element={<VisitNavigationOutlet />}>
    <Route path="" element={<Layout simplified forVisit />}>
      <Route path="policies-consent" element={<PoliciesConsentPage />} />
      <Route path="pre-screen-questions" element={<PreScreenQuestionsPage />} />
      <Route path=":visitId" element={<EncounterOutlet />}>
        <Route path="insurance-information" element={<InsuranceInformationPage />} />
        <Route path="insurance-coverage" element={<InsuranceCoveragePage />} />
        <Route path="choose-provider" element={<ProviderSelectionPage />} />
        <Route path="pharmacy-type-selection" element={<PharmacyTypeSelectionPage />} />
        <Route path="choose-pharmacy" element={<PharmacySelectionPage />} />
        <Route path="health-and-lifestyle" element={<HealthAndLifestylePage />} />
        <Route path="medical-history" element={<MedicalHistoryPage />} />
        <Route path="questions/:pageId?" element={<VariableQuestionsPage />} />
        <Route path="review" element={<ReviewPage />} />
        <Route path="payment" element={<PaymentPage />} />
        <Route path="identity-verification">
          <Route path="" element={<VouchedPage />} />
          <Route path="dependent" element={<VouchedPage key="dependent" />} />
          <Route path="rejection" element={<IdvRejectionPage />} />
          <Route path="manual-request" element={<ManualRequestPage />} />
        </Route>
      </Route>
    </Route>

    {/* These paths does not show the header navigation */}
    <Route path=":visitId" element={<EncounterOutlet />}>
      <Route path="" element={<Layout simplified />}>
        <Route path="cancel" element={<CancelVisitPage />} />
        <Route path="payment/success" element={<PaymentSuccessPage />} />
        <Route path="tx-plan/treatment" element={<TreatmentPlanPage />} />
        <Route path="tx-plan/details" element={<DetailsPage />} />
        <Route path="update-photo" element={<UpdateImagesPage />} />
      </Route>
      <Route path="tx-plan/messages" element={<MessagesPage />} />
    </Route>
  </Route>
);
